<template>
  <form v-loading="loading" :class="[$style.loginWrap]" class="login-wrap">
    <div class="left-wrap pc">
      <h1 :class="[$style.tit]">
        {{ $t('login_msg_1') }}<br />
        {{ $t('login_msg_1_1') }} <strong>{{ $t('login_msg_1_2') }}</strong>
      </h1>
      <p v-html="$t('login_msg_2')"></p>
      <img
        class="device-img"
        src="@assets/images/v2/img-device.png"
        alt="기기 이미지"
      />
      <span class="tip">TIP</span>
      <span class="bold">{{ $t('login_msg_3') }}</span>
    </div>
    <div class="right-wrap">
      <LocaleSelect
        :style="
          isMobile
            ? 'position:absolute;top:26%; right:15px; z-index:1;'
            : 'position:absolute;top:115px; right:0; z-index:1;'
        "
        :dropdown-top="isMobile ? '34px' : '38px'"
      ></LocaleSelect>

      <div class="login-logo">
        <img src="@assets/images/v2/logo-full.svg" alt="로고" />
      </div>
      <EmailVerificationLogin></EmailVerificationLogin>
    </div>
  </form>
</template>
<script>
import LocaleSelect from '@components/LocaleSelect'
import EmailVerificationLogin from '@/src/components/email-verification-login.vue'
export default {
  components: { LocaleSelect, EmailVerificationLogin },
  data() {
    return {
      windowWidth: 0,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.loginWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1080px;
  height: 100vh;
  margin: 0 auto;
  text-align: left;
  background: #fff;
}

.tit {
  margin: 0 0 10px 0;
  font-size: 34px;
  font-weight: 700;
  line-height: 40px;
  text-align: left;
  word-break: keep-all;
  strong {
    font-weight: 700;
    color: #2a5cda;
  }
}
</style>
<style scoped>
.login-wrap span {
  font-weight: normal;
  color: #999;
}
.login-wrap .tip {
  padding: 3px 9px;
  margin-right: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: white;
  background-color: #0068c1;
  border-top-left-radius: 7.14px;
  border-bottom-right-radius: 7.14px;
}
.login-wrap .bold {
  font-size: 16px;
  color: #0068c1;
}
.left-wrap {
  box-sizing: border-box;
  width: 520px;
}
.left-wrap p {
  padding-bottom: 20px;
  font-size: 16px;
  line-height: 22px;
  color: #7f8894;
}
.login-wrap .device-img {
  width: 100%;
  padding-bottom: 20px;
}
.login-wrap .login-logo {
  box-sizing: border-box;
  margin-bottom: 70px;
  text-align: center;
}
.login-wrap .login-logo img {
  width: 248px;
}
.right-wrap {
  position: relative;
  box-sizing: border-box;
  width: 382px;
}
.right-wrap .title-img {
  top: 50px;
}

@media (max-width: 768px) {
  .login-wrap {
    flex-direction: column;
    justify-content: center;
    margin: 0;
    background-image: url('../../assets/images/v2/bg-login-m.png');
    background-size: cover;
  }

  .right-wrap {
    box-sizing: border-box;
    width: 90%;
    padding: 40px 15px 60px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 1px 1px 12px 0 #8cc2d71a;
    backdrop-filter: blur(24px);
  }
  .login-wrap .device-img {
    width: 100%;
    padding: 40px 0;
    text-align: center;
  }

  .login-wrap .login-logo img {
    width: 190px;
  }
  .device-img {
    display: none;
  }
}
</style>
